import React, { useState, useContext, useEffect } from "react";
import {
  Backdrop,
  Slide,
  Paper,
  makeStyles,
  Container,
  Box,
  Typography,
  Avatar,
  useTheme,
  Grid,
  Button,
  Tabs,
  Tab,
  ClickAwayListener,
  CircularProgress,
  Link,
  Collapse,
} from "@material-ui/core";
import LastModified from "../../components/LastModified/LastModified";
import ConfigurationListsContext from "../../context/configurationListsContext";
import { CustomTab } from "../Jobs/JobsList/JobDashboard/CandidateTabs";
import CompanyContacts from "./CompanyContacts";
import CompanySignals from "./CompanySignals";
import axios from "axios";

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  container: {
    zIndex: 1,
    position: "absolute",
    margin: theme.spacing(1),
    width: "40%",
    minWidth: 600,
    height: "100vh",
    right: 0,
    padding: theme.spacing(2),
    background: theme.palette.background.default,
    "& .MuiPaper-root": {
      padding: theme.spacing(2),
      boxShadow:
        "0px 6px 116px rgba(164, 166, 179, 0.21), 0px 1.80882px 34.9706px rgba(164, 166, 179, 0.136834), 0px 0.751293px 14.525px rgba(164, 166, 179, 0.105), 0px 0.271728px 5.25341px rgba(164, 166, 179, 0.0731663)",
      borderRadius: 16,
    },
    "& .MuiTab-root": {
      minWidth: 120,
    },
    "& .MuiTabs-indicator": {
      height: 4,
      borderRadius: 4,
    },
    zIndex: theme.zIndex.drawer + 10,
  },
  wrapper: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const SingleCompanyFullDetails = ({
  company,
  onClose,
  onContactsRemove,
  onSignalUpdate,
  initialTab,
  signalCategories,
  onSave,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const usersContextList = useContext(ConfigurationListsContext).users;
  const [activeTab, setActiveTab] = useState(initialTab === "signal" ? 1 : 0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);

  const handleGetToken = async () => {
    try {
      setIsLoading(true);
      const token = await axios.get(
        `/wp-json/api/v2/company_preferences_token/${company.id}`
      );
      setToken(token.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError(err.response);
      setToken(null);
    }
  };

  return (
    <Backdrop className={classes.backdrop} open={company.id > 0}>
      <ClickAwayListener onClickAway={onClose}>
        <Slide direction="left" in={company.id > 0} mountOnEnter unmountOnExit>
          <Container className={classes.container}>
            <Paper>
              <Box
                display={"flex"}
                justifyContent="space-between"
                alignItems={"center"}
              >
                <Typography variant="h5" color="textPrimary">
                  {company.name}
                </Typography>

                <Avatar
                  src={company.logo ? company.logo : null}
                  alt="company"
                  variant="circular"
                />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Box
                    my={2}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="flex-start"
                  >
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      style={{ marginRight: theme.spacing(2) }}
                    >
                      Address:
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      {company.address}
                    </Typography>
                  </Box>
                  <Box
                    my={2}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="flex-start"
                  >
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      style={{ marginRight: theme.spacing(2) }}
                    >
                      Company ID:
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      {company.id}
                    </Typography>
                  </Box>
                  <Box
                    my={2}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="flex-start"
                  >
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      style={{ marginRight: theme.spacing(2) }}
                    >
                      Preferences Link:
                    </Typography>
                    <div className={classes.wrapper}>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleGetToken}
                      >
                        SHOW
                      </Button>
                      {isLoading && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </div>
                  </Box>
                  <Collapse in={token}>
                    <Box>
                      <Link
                        href={`/company-signal-preferences/${token}`}
                        color="primary"
                        target="_blank"
                        rel="noopener"
                      >
                        PREFERENCES LINK
                      </Link>
                    </Box>
                  </Collapse>
                </Grid>
                <Grid item xs={4}>
                  <Box
                    my={2}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="flex-start"
                  >
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      style={{ marginRight: theme.spacing(2) }}
                    >
                      Added:
                    </Typography>

                    <LastModified toDate={company.creation_date} />
                  </Box>
                  <Box
                    my={2}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="flex-start"
                  >
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      style={{ marginRight: theme.spacing(2) }}
                    >
                      Owner:
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      {
                        usersContextList.find(
                          (user) => user.id === parseInt(company.author)
                        ).display_name
                      }
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
            <Box my={2}>
              <Paper>
                <Box
                  display={"flex"}
                  justifyContent="space-between"
                  alignItems={"center"}
                >
                  <Box>
                    <Tabs
                      value={activeTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={(event, value) => setActiveTab(value)}
                      className={classes.tabs}
                    >
                      {["Contacts", "Signal"].map((tab, index) => {
                        return (
                          <Tab
                            label={
                              <CustomTab
                                total={
                                  index === 0 ? company.contacts.length : 0
                                }
                                label={tab}
                              />
                            }
                            key={tab}
                            disabled={tab === "Signal" && !company.is_signal}
                            {...a11yProps(index)}
                          />
                        );
                      })}
                    </Tabs>
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={onSave}
                  >
                    Save
                  </Button>
                </Box>
                <Box my={2}>
                  {activeTab === 0 ? (
                    <CompanyContacts
                      contacts={company.contacts}
                      onContactsRemove={(contactid) =>
                        onContactsRemove(company.id, contactid)
                      }
                    />
                  ) : (
                    <CompanySignals
                      selectedSignals={company.signals}
                      signalCategories={signalCategories}
                      onSignalUpdate={onSignalUpdate}
                    />
                  )}
                </Box>
              </Paper>
            </Box>
          </Container>
        </Slide>
      </ClickAwayListener>
    </Backdrop>
  );
};
export default SingleCompanyFullDetails;
